<template lang="pug">
  div(class="vkb-nak-chart")
    highcharts(:options="chartOptions" ref="highcharts")
</template>

<script>
import { formatMoney } from '../../modules/utils';
export default {
  name: 'riester_rente_chart',
  props: {
    data: Array,
    height: {
      type: [ Number, String ],
      default: 400
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: this.height,
          type: 'pie'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        legend: {
          layout: 'vertical',
          itemMarginTop: 5,
          itemMarginBottom: 5,
          squareSymbol: false,
          symbolRadius: 0,
          symbolHeight: 16,
          symbolWidth: 71,
          labelFormat: '{name}: {formattedValue} €'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
              format: '{point.name}: {point.formattedValue} €',
              style: { fontWeight: 'normal' }
            },
            showInLegend: true
          }
        },
        series: [{
          name: '',
          colorByPoint: true,
          showInLegend: true,
          data: this.data.map(_item => ({
            color: _item.color,
            name: _item.name,
            sliced: _item.selected,
            selected: _item.selected,
            y: _item.value,
            formattedValue: formatMoney(_item.value, 2),
          }))
        }]
      }
    };
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/apps/riester_rente/chart.vue